import { render } from "./BaseBadge.vue?vue&type=template&id=c0374c7c&scoped=true"
import script from "./BaseBadge.vue?vue&type=script&lang=js"
export * from "./BaseBadge.vue?vue&type=script&lang=js"

import "./BaseBadge.vue?vue&type=style&index=0&id=c0374c7c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c0374c7c"

export default script